module.exports = __webpack_public_path__ + "img/7-23.eea4b69b.jpg";